import React, { useState, lazy } from 'react';
import PropTypes from 'prop-types';
import RenderComponent from './RenderComponent';
import { periodList } from 'globalconfig/constants/keys';
import { getQueryStringKeys } from 'globalutils/fmUtils';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const Filters = ({
  hasApiStatus,
  callback,
  history,
  filterList,
  handleReset,
  values,
  setInitialValues
}) => {
  const [validationError, setValidationError] = useState('');
  const queryPeriod = getQueryStringKeys(history.location.search, 'period');

  const handleSubmit = (fields) => {
    setValidationError('');
    const finalData = { ...fields, period: fields.period?.value };

    if (fields.period?.value) {
      Object.keys(finalData).forEach(
        (key) => !finalData[key] && delete finalData[key]
      );
      filterList(finalData);
    } else {
      setValidationError('Please select filter');
    }
  };

  const handleCancel = () => {
    handleReset();
    setInitialValues({
      period: periodList.find((ele) => ele.value === queryPeriod)
    });
    setValidationError('');
  };

  return (
    <Form
      type="server"
      direction="row"
      initialValues={{ ...values }}
      className="CSAForms"
      RenderComponent={RenderComponent}
      handleOnSubmit={handleSubmit}
      handleOnCancel={handleCancel}
      customProps={{
        history,
        callback,
        hasApiStatus,
        validationError,
        setInitialValues
      }}
    />
  );
};

Filters.propTypes = {
  hasApiStatus: PropTypes.bool.isRequired,
  callback: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  filterList: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  setInitialValues: PropTypes.func.isRequired
};

export default Filters;